// import React from "react";
// import {
//     FaAddressCard,
//     FaFacebook,
//     FaTwitter,
//     FaWhatsapp,
//     FaYoutube,
// } from "react-icons/fa";
// import { RiInstagramFill } from "react-icons/ri";
// import { IoCallOutline } from "react-icons/io5";
// import { Link } from "react-router-dom";
// import macrolifelogo from "../images/macrolifelogo3.png";
// import Applebtn from "../images/apple-downld-btn.jpeg";
// import Googlebtn from "../images/google-playstore.png";

// const Footer = () => {
//     return (
//         <div className="px-6 py-10 bg-purple-500 text-white relative z-0">
//             <div className="grid sm:grid-cols-2 lg:flex lg:justify-between lg:gap-8 md:gap-5 max-w-[1280px] mx-auto">
//                 <div className="lg:w-1/2 mb-6 lg:mb-0">
//                     <img
//                         src={macrolifelogo}
//                         alt="logo"
//                         className="w-52 h-40"
//                     />
//                     <p className="mt-3 text-sm">
//                         Our MicroLife is an innovative e-commerce platform connecting buyers
//                         and trusted vendors, offering a seamless shopping experience with
//                         diverse products, competitive prices, and reliable services tailored
//                         to your needs.
//                     </p>
//                     <div className="flex pt-3 space-x-4">
//                         <a
//                             href="https://www.facebook.com/profile.php?id=61565135771389&mibextid=ZbWKwL"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             aria-label="Facebook"
//                             className="text-white"
//                         >
//                             <FaFacebook size={30} />
//                         </a>
//                         <a
//                             href="https://www.instagram.com/microlifeour?igsh=c3E1M2IzYzc4NGxl"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             aria-label="Instagram"
//                             className="text-white"
//                         >
//                             <RiInstagramFill size={30} />
//                         </a>
//                         <a
//                             href="https://www.twitter.com"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             aria-label="Twitter"
//                             className="text-white"
//                         >
//                             <FaTwitter size={30} />
//                         </a>
//                         <a
//                             href="https://youtube.com/@microlifeour?si=L5Vwka7mUrtTjHcL"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             aria-label="YouTube"
//                             className="text-white"
//                         >
//                             <FaYoutube size={30} />
//                         </a>
//                     </div>
//                 </div>

//                 <div className="lg:w-1/2 mb-6 lg:mb-0">
//                     <h2 className="text-[18px] md:text-[20px] font-medium pt-5 pb-3">
//                         Most Popular Categories
//                     </h2>
//                     <ul className="space-y-2 text-sm md:text-base">
//                         <li>Home care</li>
//                         <li>Personal care</li>
//                         <li>Beauty</li>
//                         <li>Health & Wellness</li>
//                         <li>Kitchen essentials</li>
//                         <li>Electronics</li>
//                         <li>Furniture</li>
//                         <li>
//               <Link to="/documents" className="text-white hover:underline">
//                 Documents
//               </Link>
//             </li>
//                     </ul>
//                 </div>

//                 <div className="lg:w-1/2 mb-6 lg:mb-0">
//                     <h2 className="text-[18px] md:text-[20px] font-medium pt-5 pb-3">
//                         Customer Services
//                     </h2>
//                     <ul className="space-y-2 text-sm md:text-base">
//                         <Link to="/about_us">
//                             <li>About Us</li>
//                         </Link>
//                         <Link to="/privacy_policy">
//                             <li>Privacy Policy</li>
//                         </Link>
//                         <Link to="/terms_conditions">
//                             <li>Terms and Conditions</li>
//                         </Link>

//                         <Link to="/refund_cancellation">
//                             <li>Refund & Cancellation</li>
//                         </Link>
//                         <Link to="/contact_us">
//                             <li>Contact Support</li>
//                         </Link>
//                         <Link to="/shipping_returns">
//                             <li>Shipping & Delivery</li>
//                         </Link>
//                     </ul>
//                 </div>

//                 <div className="lg:w-1/2">
//                     <Link to="/contact_us">
//                         <h2 className="text-[18px] md:text-[20px] font-medium pt-5">
//                             Contact Us
//                         </h2>
//                     </Link>
//                     <div className="flex items-center pt-4 space-x-2">
//                         <a
//                             href="https://wa.me/919955661643"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="text-white flex items-center space-x-2"
//                         >
//                             <FaWhatsapp />
//                             <span>+91 9955661643</span>
//                         </a>
//                     </div>

//                     <div className="flex items-center pt-4 space-x-2">
//                         <a href="tel:+919955661643" className="text-white flex items-center space-x-2">
//                             <IoCallOutline />
//                             <span>+91 9955661643</span>
//                         </a>
//                     </div>
//                     <div className="flex items-center pt-4 space-x-2">
//                         <FaAddressCard className="text-white" />
//                         <div>
//                             <p className="text-sm max-w-52">
//                                 112 Modi Towar, 98 Nehru Place, New Delhi 110019
//                             </p>
//                         </div>
//                     </div>
//                     {/* download app  */}
//                     <div className="pt-4">
//                         <h3 className="text-[18px] md:text-[20px] font-medium">
//                             Download App
//                         </h3>
//                         <div className="flex space-x-4 mt-2">
//                             <a
//                                 href="https://play.google.com/store"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="flex items-center"
//                             >
//                                 <img
//                                     src={Googlebtn}
//                                     alt="Download on Google Play"
//                                     className="w-[120px] md:w-[150px] h-[37px] md:h-[48px] object-contain"
//                                 />
//                             </a>
//                             <a
//                                 href="https://apps.apple.com/us/app/idXXXXXXXXX"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="flex items-center"
//                             >
//                                 <img
//                                     src={Applebtn}
//                                     alt="Download on App Store"
//                                     className="w-[120px] md:w-[150px] h-[45px] rounded-lg object-contain"
//                                 />
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             </div>
//             );
// };

//             export default Footer;


import React from "react";
import {
  FaAddressCard,
  FaFacebook,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { IoCallOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import macrolifelogo from "../images/macrolifelogo3.png";
import Applebtn from "../images/apple-downld-btn.jpeg";
import Googlebtn from "../images/google-playstore.png";

const Footer = () => {
  return (
    <div className="px-6 py-10 bg-gradient-to-r from-purple-600 via-indigo-500 to-purple-600 text-white relative z-0">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-[1280px] max-h-auto`````` mx-auto">
        {/* Logo Section */}
        <div className="lg:max-w-full mb-6 lg:mb-0">
          <img src={macrolifelogo} alt="logo" className="w-52 h-40 mb-4" />
          <p className="mt-3 text-sm md:text-base opacity-80">
            Our MicroLife is an innovative e-commerce platform connecting buyers and trusted vendors,
            offering a seamless shopping experience with diverse products, competitive prices, and reliable services tailored to your needs.
          </p>
          <div className="flex pt-4 space-x-4">
            <a
              href="https://www.facebook.com/profile.php?id=61565135771389&mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="text-white hover:text-blue-500 transition-all"
            >
              <FaFacebook size={30} />
            </a>
            <a
              href="https://www.instagram.com/microlifeour?igsh=c3E1M2IzYzc4NGxl"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-white hover:text-pink-500 transition-all"
            >
              <RiInstagramFill size={30} />
            </a>
            <a
              href="https://www.twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="text-white hover:text-blue-400 transition-all"
            >
              <FaTwitter size={30} />
            </a>
            <a
              href="https://youtube.com/@microlifeour?si=L5Vwka7mUrtTjHcL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="text-white hover:text-red-500 transition-all"
            >
              <FaYoutube size={30} />
            </a>
          </div>
        </div>

        {/* Popular Categories Section */}
        <div className="lg:max-w-full mb-6 lg:mb-0">
          <h2 className="text-[20px] font-medium pt-5 pb-3 text-white">Most Popular Categories</h2>
          <ul className="space-y-2 text-sm md:text-base">
            <li className="hover:text-purple-200 transition-all">Home care</li>
            <li className="hover:text-purple-200 transition-all">Personal care</li>
            <li className="hover:text-purple-200 transition-all">Beauty</li>
            <li className="hover:text-purple-200 transition-all">Health & Wellness</li>
            <li className="hover:text-purple-200 transition-all">Kitchen essentials</li>
            <li className="hover:text-purple-200 transition-all">Electronics</li>
            <li className="hover:text-purple-200 transition-all">Furniture</li>
            <li>
              <Link to="/documents" className="text-white hover:underline transition-all">
                Documents
              </Link>
            </li>
          </ul>
        </div>

        {/* Customer Services Section */}
        <div className="lg:max-w-full lg:mb-0">
          <h2 className="text-[20px] font-medium pt-5 pb-3 text-white">Customer Services</h2>
          <ul className="space-y-2 text-sm md:text-base">
            <Link to="/about_us">
              <li className="hover:text-purple-200 transition-all">About Us</li>
            </Link>
            <Link to="/privacy_policy">
              <li className="hover:text-purple-200 transition-all">Privacy Policy</li>
            </Link>
            <Link to="/terms_conditions">
              <li className="hover:text-purple-200 transition-all">Terms and Conditions</li>
            </Link>
            <Link to="/refund_cancellation">
              <li className="hover:text-purple-200 transition-all">Refund & Cancellation</li>
            </Link>
            <Link to="/contact_us">
              <li className="hover:text-purple-200 transition-all">Contact Support</li>
            </Link>
            <Link to="/shipping_returns">
              <li className="hover:text-purple-200 transition-all">Shipping & Delivery</li>
            </Link>
          </ul>
        </div>

        {/* Contact Us Section */}
        <div className="lg:max-w-full">
          <h2 className="text-[20px] font-medium pt-5 text-white">Contact Us</h2>
          <div className="flex items-center pt-4 space-x-2">
            <a
              href="https://wa.me/919955661643"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white flex items-center space-x-2 hover:text-green-400 transition-all"
            >
              <FaWhatsapp />
              <span>+91 9955661643</span>
            </a>
          </div>

          <div className="flex items-center pt-4 space-x-2">
            <a
              href="tel:+919955661643"
              className="text-white flex items-center space-x-2 hover:text-yellow-400 transition-all"
            >
              <IoCallOutline />
              <span>+91 9955661643</span>
            </a>
          </div>
          <div className="flex items-center pt-4 space-x-2">
            <FaAddressCard className="text-white" />
            <div>
              <p className="text-sm max-w-52">112 Modi Towar, 98 Nehru Place, New Delhi 110019</p>
            </div>
          </div>

          {/* Download App Section */}
          <div className="pt-4">
            <h3 className="text-[20px] font-medium text-white">Download App</h3>
            <div className="flex space-x-4 mt-2">
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center"
              >
                <img
                  src={Googlebtn}
                  alt="Download on Google Play"
                  className="w-[120px] md:w-[150px] h-[37px] md:h-[48px] object-contain"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/idXXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center"
              >
                <img
                  src={Applebtn}
                  alt="Download on App Store"
                  className="w-[120px] md:w-[150px] h-[45px] rounded-lg object-contain"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
